import React from 'react';

const Navbar = () => {
  return (
    <nav>
      <h1> Jordan Lerat</h1>

      <div>
        <a href="#home">Home</a>
        <a href="#work">Work</a>
        <a href="#skills">Skills</a>
        <a href="#resources">Resources</a>
        <a href="#setup">Setup</a>
      </div>
    </nav>
  );
};

export default Navbar;
